import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { UserInfoService } from './services/user-info-service';
import { UserInfoServiceImpl } from './services/impls/user-info-service';

export const userInfoModule = new ContainerModule((bind) => {
    bind(UserInfoService).to(UserInfoServiceImpl);
});

export { UserInfoService };
